import { CookiesPopup } from '@r-and-a-shared-ui/common-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type {
  MEMBERSHIP_MODELS,
  PLAYER_PORTALS_MODELS,
} from '@r-and-a-shared-ui/common-kontent-client';

export default {
  component: () => CookiesPopup,
  mapEntryToProps: (
    entry: MEMBERSHIP_MODELS.CookiesPopup & PLAYER_PORTALS_MODELS.CookiesPopup,
  ) => kontentAiDataMapping.cookie_popup(entry),
};
